package horcrux.common.api.dtos

import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.common.api.dtos.types.CollectionName
import horcrux.common.api.dtos.types.DocumentIDAndName
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.api.dtos.types.UserID
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable

@Serializable
enum class EmbeddingModelID(val modelID: String) {
    TEXT_EMBEDDING_3_SMALL("text-embedding-3-small"),
    CLIP_VIT_B_32("clip-ViT-B-32");
}

@Serializable
data class PostCollectionRequest(
    val collectionName: CollectionName,
    val embeddingModelID: EmbeddingModelID,
) : HorcruxValidatedRequest

@Serializable
data class PostCollectionResponse(
    val collectionMetadata: CollectionMetadata
) : HorcruxResponse

@Serializable
data class GetCollectionResponse(val documentMetadataList: List<DocumentMetadata>) : HorcruxResponse

@Serializable
data class PatchCollectionRequest(
    val collectionID: CollectionID, val newCollectionName: CollectionName
) : HorcruxValidatedRequest

@Serializable
data class PatchCollectionResponse(val collectionMetadata: CollectionMetadata) : HorcruxResponse

@Serializable
class DeleteCollectionRequest(val collectionID: CollectionID) : HorcruxValidatedRequest

@Serializable
class DeleteCollectionResponse : HorcruxResponse

@Serializable
enum class CollectionPrivacyType {
    PRIVATE, PUBLIC;
}

@Serializable
data class PutCollectionRequest(
    val collectionID: CollectionID,
    val collectionPrivacyType: CollectionPrivacyType,
    val collectionNameMaybe: CollectionName? = null,
) : HorcruxValidatedRequest

@Serializable
data class PutCollectionResponse(
    val newCollectionMetadata: CollectionMetadata
) : HorcruxResponse

open class PutCollectionError(httpStatusCode: HttpStatusCode) : HorcruxRequestSimpleError(httpStatusCode)

data class ErrorCreatingDocumentParentDatabaseEntries(
    val documentIDAndNames: List<DocumentIDAndName>,
    val collectionID: CollectionID,
    val userID: UserID,
    override val cause: Throwable?
) :
    PutCollectionError(
        HttpStatusCode.BadGateway
    )
